<template>
  <div
    class="m-wap-footer new"
    v-if="extras.groupFooterDisplay && extras.groupFooterDisplay.display == 1"
    :style="{
      background:
        extras.footerBg.colorOrBg == 'color'
          ? extras.footerBg.color
          : 'url(' + extras.footerBg.src + ')',
    }"
  >
    <div class="top-nav">
      <div class="footer-inner">
        <div class="_left">
          <div class="top">
            <div class="logo-img">
              <img
                v-if="extras.footerLogo.display"
                :src="extras.footerLogo.src"
                alt=""
              />
            </div>
            <div class="content">
              <div
                class="title"
                v-if="extras.footerTextStyle.title != 'hide'"
                :style="{
                  color:
                    extras.footerTextStyle.title == 'custom'
                      ? extras.footerTextStyle.fontColor
                      : '',
                  'font-size':
                    extras.footerTextStyle.title == 'custom'
                      ? extras.footerTextStyle.fontSize + 'px'
                      : '',
                  'font-style':
                    extras.footerTextStyle.title == 'custom'
                      ? extras.footerTextStyle.fontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    extras.footerTextStyle.title == 'custom'
                      ? extras.footerTextStyle.fontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                }"
              >
                {{ extras.contact.model || "联系我们" }}
              </div>
              <div
                v-if="extras.footerTextStyle.content != 'hide'"
                :style="{
                  color:
                    extras.footerTextStyle.content == 'custom'
                      ? extras.footerTextStyle.fontColor2
                      : '',
                  'font-size':
                    extras.footerTextStyle.content == 'custom'
                      ? extras.footerTextStyle.fontSize2 + 'px'
                      : '',
                  'font-style':
                    extras.footerTextStyle.content == 'custom'
                      ? extras.footerTextStyle.fontTilt2 == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    extras.footerTextStyle.content == 'custom'
                      ? extras.footerTextStyle.fontWeight2 == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                }"
              >
                {{ extras.content.model || "合作联系 xxx.xxx@outlook.com" }}
              </div>
            </div>
          </div>
          <div
            class="bottom"
            v-if="extras.footerTextStyle.copyright != 'hide'"
            :style="{
              color:
                extras.footerTextStyle.copyright == 'custom'
                  ? extras.footerTextStyle.fontColor3
                  : '',
              'font-size':
                extras.footerTextStyle.copyright == 'custom'
                  ? extras.footerTextStyle.fontSize3 + 'px'
                  : '',
              'font-style':
                extras.footerTextStyle.copyright == 'custom'
                  ? extras.footerTextStyle.fontTilt3 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.footerTextStyle.copyright == 'custom'
                  ? extras.footerTextStyle.fontWeight3 == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
          >
            <!--<div class="company">北京xx有限公司</div>-->
            <div>
              {{
                extras.copyright.model || "Copyright ©2023 All rights reserved."
              }}
            </div>
            <!--<div>京公网安备 xxxxxxxxxxxxxxx号 </div>-->
            <!--<div>Copyright ©2023 北京xxx有限公司 All rights reserved.</div>-->
          </div>
        </div>
        <div class="qr-code">
          <img v-if="extras.qrcode.display" :src="extras.qrcode.src" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    extras: Object,
  },
};
</script>

<style scoped></style>
